import React from "react";

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
 as?: keyof JSX.IntrinsicElements;
 children?: React.ReactNode;
}

export const Box = React.forwardRef<HTMLDivElement, BoxProps>(
 ({ as: Component = "div", children, className = "", ...props }, ref) => {
  return React.createElement(
   Component,
   { ref, className, ...(props as any) },
   children
  );
 }
);

Box.displayName = "Box";

export default Box;

